import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Title = styled.div`
  ${typographyV2.titleMd}
  color: var(--text-default);
  margin-bottom: 16px;
`;

export const StyledTitleCell = styled.div`
  max-width: 200px;
  padding: 8px;
  white-space: pre-wrap;
  ${typographyV2.bodySm}
`;

export const StyledDescriptionCell = styled.div`
  flex: 1;
  padding: 8px;
  white-space: pre-wrap;
  ${typographyV2.bodySm}
  width:468px;
`;

export const StyledRatingPill = styled.div`
  width: 100px;
`;
